module.exports = __webpack_public_path__ + "static/media/Image_13.4bdb86bc.png";